import React, { Component, Fragment } from 'react';
import Confirmation from './../../components/commonComponents/confirmationBox';
import endCallIcon from './../../globals/images/end-call.png';
import Chat from "./../container/chat";
import Timer from "../callTimer/timer";
import MeetingImage from './meetingImage';
import getLabel from './../../utils/labels'
import selectedActorImage from './../../globals/images/meeting-jane-colored.png';
import unselectedActorImage from './../../globals/images/meeting-jane.png';
import "./meeting.css";
import _ from "lodash";

class App extends Component {
    constructor() {
        super();
        this.state = {
            data: [],
            isTimerOn: true,
            isConfirmationBoxOpen: false
        }
    }
    chatDataSetter = (data) => {
        this.setState({
            data
        })
    }

    chatCompleted = () => {
        let meetingAnswers = this.state.data.filter(chat => chat.type === 'mcq')
        meetingAnswers = meetingAnswers.map(chat => {
            return {
                questionId: chat.id,
                optionId: chat.userOptionId
            }
        });

        let meetingPostData = {
            primaryMailId: this.props.meetingDetail.id,
            surveyId: 3,
            actionTakenAt: this.getCurrentTime(),
            surveyAnswers: meetingAnswers
        }

        this.props.postSurveyResponse(meetingPostData).then((response) => {
            if (response.sucess) {
                this.setState({
                    completed: true
                });
                this.stopTimer(3000);
            }
        });
    }

    stopTimer = (time = 100) => {
        this.setState({
            isTimerOn: false
        });
        this.props.terminateCall({
            primaryMailId: this.props.meetingDetail.id
        }).then((response) => {
            if (response.sucess) {
                this.timerForCall = setTimeout(() => {
                    this.endCallDialog();
                    this.props.setCallEndedFlag({
                        primaryMailId: this.props.meetingDetail.id
                    })
                    this.props.endMeeting()
                }, time);
            }
        });
    }

    getCurrentTime = () => {
        return this.props.getTimeData().timeLeft;
    }

    endCallDialog = () => {
        this.props.closeCallContainer()
    }

    openConfirmationBox = () => {
        this.setState({
            isConfirmationBoxOpen: true
        })
    }

    closeConfirmationBox = () => {
        this.setState({
            isConfirmationBoxOpen: false
        })
    }

    render() {
        let { statements, questions, meetingImages } = this.props.meetingDetail.survey;
        let { selfActor } = this.props;
        statements = _.orderBy(statements, ['id'], ['asc'])
        questions = _.orderBy(questions, ['id'], ['asc'])

        let lastOne = this.state.data[this.state.data.length - 1];
        let index = 0;
        let chatContainerHeight = '480px';

        let selfActorImage = this.props.actors.inActors.find(actor => actor.id === selfActor).gravatar;
        // let fromActorImage = lastOne.fromActor
        if (lastOne) {
            index = this.state.data.length - 1;
        }

        //this should be done in the original images - temporary fix for now
        let selfActorInMeeting = null;
        if (this.state.data.length > 0 && this.state.data[index].fromActor === selfActor) {
            selfActorInMeeting = selectedActorImage
        } else {
            selfActorInMeeting = unselectedActorImage
        }

        let actorsList = [...this.props.actors.inActors, ...this.props.actors.clients]

        return (
            <Fragment>
                <div className="meeting-wrap">
                    <div className="meeting-header chat-text">
                        <span style={{ marginRight: '15px' }}>{getLabel('label_team_meeting')}</span>
                        <Timer isTimerOn={this.state.isTimerOn} />
                    </div>
                    <div className="meeting-layout">
                        <div className="image-slider">
                            <MeetingImage
                                meetingActors={meetingImages}
                                actorsList={actorsList}
                                data={this.state.data}
                                selfActorId={selfActor}
                            />
                            {/* <div className="self-image">
                                <img src={selfActorInMeeting} />
                            </div>
                            <img src={meetingImages[index]} className="message-image" /> */}
                        </div>
                        <div className="meeting-chat-wrap">
                            <Chat
                                chatDataSetter={this.chatDataSetter}
                                chatCompleted={this.chatCompleted}
                                questions={questions}
                                statements={statements}
                                selfActor={selfActor}
                                selfActorImage={selfActorImage}
                                chatContainerHeight={chatContainerHeight}
                                actors={this.props.actors}//For tutorial
                                tutorial={this.props.tutorial}
                            />
                        </div>
                    </div>
                    <div className="call-footer">
                        <img src={endCallIcon} style={{ margin: '0 10px', cursor: 'pointer' }} onClick={this.openConfirmationBox} />
                    </div>
                    {this.state.completed && <div className="message-ended"><div>{getLabel('label_team_meeting_end_message')}</div></div>}
                </div >
                {
                    this.state.isConfirmationBoxOpen ?
                        <Confirmation
                            acceptButtonText={getLabel('label_end_button')}
                            confimationMessage={getLabel('label_meeting_end_confirmation')}
                            onAcceptClick={this.stopTimer}
                            onCancelClick={this.closeConfirmationBox} />
                        :
                        null
                }
            </Fragment>
        );
    }
}

export default App;



// WEBPACK FOOTER //
// /src/call/meeting/meeting.js